import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import fr from 'facet-rest';
import useCollectionState from 'Hooks/useCollectionState';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import NullComponent from 'Components/UI/NullComponent';
import { useRefreshModalCollectionCleared } from 'Hooks/useRefreshEvent';
import { HeroLayout } from './HeroLayout';
import { metaOverrideSet } from './metaOverrideSet';

export const HeroLoader = ({ resource }) => {
  const rel = resource.withRelationship(
    fr.relationships.filingHero.name,
    (filingRel) => filingRel,
    () => resource.relationship(fr.relationships.hero.name),
  );

  const {
    isInitializing, loadingError, collection, refreshCollection,
  } = useCollectionState({ relationship: rel });

  // If you exit a modal, let's refresh this content because it may have changed
  useRefreshModalCollectionCleared(() => {
    refreshCollection();
  }, [refreshCollection]);

  return (
    <DataContainer
      component={collection ? MetaResourceRenderer : NullComponent}
      componentProps={{
        layout: HeroLayout,
        metaOverrideSet,
        resource: collection?.resources()?.head(),
      }}
      loading={isInitializing}
      loadingError={loadingError}
    />
  );
};
